// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ##### -> Components ->  ProjectOverView, AsbuiltDiagram  */

.asbuilt_div {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  position:relative
}

.asbuilt_div>:first-child {
  box-sizing: border-box;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* margin: 1vmax 0; */
  border-bottom: 2px solid rgb(33, 38, 80);
  /* margin-bottom: 1.5vmax; */
  padding: 0.5vmax 5vmax;
  color: rgb(7, 61, 128);
}

.asbuilt_div>:first-child>:first-child {
  font-size: 2.5vmax;
  letter-spacing: 0.2vmax;

}

.asbuilt_div>:first-child>:last-child {
  font-size: 0.9vmax;
  letter-spacing: 0.1vmax;
}

.asbuilt_div>:last-child {
  box-sizing: border-box;
  width: 100%;
  min-height: 70vh;
  padding: 0 2vmax;
  display: flex;
  justify-content: space-between;

}


.asbuilt_div>:last-child>:first-child {
  border-right: 3px solid black;
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  flex-direction: column;
  padding: 1vmax 0.5vmax 5vmax 1vmax;
}

.asbuilt_div>:last-child>:first-child>span {
  letter-spacing: 0.1vmax;
}

.asbuilt_div>:last-child>:first-child>ul {
  padding: 0.5vmax 0;
  margin: 0;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  font-size: 1.3vmax;
  text-align: end;

}

.asbuilt_div>:last-child>:first-child>ul>li {
  list-style: none;
  cursor: pointer;
  color: black;
  padding: 0.4vmax 0.8vmax;
  position: relative;
  letter-spacing: 0.050vmax;
  font-weight: 500;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}

/* ##### Code for Module and SLD container  */


.module_div>li,
.sld_div>li{
  color: black;
}
.module_div,
.sld_div {
  white-space: nowrap;
  overflow: hidden;
  position: absolute;
  z-index: 1;
  height: auto;
  left: 100%;
  top: 15%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.3vmax;
  border-radius: 4px;
  /* box-shadow: rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset; */
  /* box-shadow: 1px 1px 1px 2px black; */
  /* background: linear-gradient(to right, #e8f8f4, #c6d5cf); */
  /* border: 2px solid black; */
  background: #fff;
  background-color: #e8f8f4;
  /* transition: width .5s ease-in-out; */
  /* transition: .5s ease-in-out; */
}
.module_div li:hover,
.sld_div li:hover{
  transition: .2s ease-out;
 font-weight: 800;
}
.asbuilt_div>:last-child>:last-child {
  box-sizing: border-box;
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  padding: 1vmax;
  gap: 1.5vmax;



}

.asbuilt_div>:last-child>:last-child>div {
  height: 18vmax;
  width: 13vmax;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5vmax;


}

.asbuilt_div>:last-child>:last-child>div>div {
  height: 100%;
  width: 100%;
  box-shadow: 2px 2px 4px black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;


}

.asbuilt_div>:last-child>:last-child>div>div>:first-child {
  background: linear-gradient(to bottom, rgb(131, 131, 255), rgb(66, 227, 255));
  background: linear-gradient(to right, #e8f8f4, #c6d5cf);
  /* background: linear-gradient(to right, #bde3fd, #73c3fc); */
  padding: 0.5vmax;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5em;
  font-size: 1.2vmax;
  font-weight: 600;
  opacity: 1.7;


}

.asbuilt_div>:last-child>:last-child>div>div>:last-child {
  background-color: rgb(248, 95, 65);
  cursor: pointer;
  width: 100%;
  padding: 0.5vmax 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5vmax;
  font-weight: 700;
  transition: .5s all;
}

.asbuilt_div>:last-child>:last-child>div>div>:last-child:hover {
  background-color: rgb(255, 46, 4) !important;

}
.asbuilt_div>:last-child>:last-child>div>:last-child>link {
  color: #05c059;
}
.categories {
  font-size: 1.7vmax;
  padding: 1vmax 0;
  padding-right: 0.5vmax;
  border-bottom: 3px solid black;
  width: -moz-fit-content;
  width: fit-content;
  text-align: end;
  font-weight: 600;
}

#excel_button,
#pdf_button {
  font-size: 1.2vmax;

}

#excel_button:hover {
  background-color: #03db64 !important;
}

@media screen and (max-width:660px) {
  .categories {
    font-size: 1.4vmax;
  }

  .asbuilt_div>:last-child {
    min-height: 45vh;
  }

  .asbuilt_div>:first-child>:first-child {
    font-size: 3.5vmax;
  }

  .asbuilt_div>:first-child>:last-child {
    font-size: 1.2vmax;
  }
}

@media screen and (max-width:550px) {

}`, "",{"version":3,"sources":["webpack://./src/modules/projectOverView/ProjOverView.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX;AACF;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,wCAAwC;EACxC,4BAA4B;EAC5B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;;AAEzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;;AAEhC;;;AAGA;EACE,6BAA6B;EAC7B,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,sEAAsE;AACxE;;AAEA,6CAA6C;;;AAG7C;;EAEE,YAAY;AACd;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,4GAA4G;EAC5G,uCAAuC;EACvC,6DAA6D;EAC7D,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,uCAAuC;EACvC,iCAAiC;AACnC;AACA;;EAEE,wBAAwB;CACzB,gBAAgB;AACjB;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,eAAe;EACf,cAAc;EACd,YAAY;;;;AAId;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;;;AAGd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;;;AAGpB;;AAEA;EACE,6EAA6E;EAC7E,uDAAuD;EACvD,6DAA6D;EAC7D,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;;;AAGd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;;AAE9C;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;;AAEpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;AAEA","sourcesContent":["/* ##### -> Components ->  ProjectOverView, AsbuiltDiagram  */\n\n.asbuilt_div {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  position:relative\n}\n\n.asbuilt_div>:first-child {\n  box-sizing: border-box;\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  /* margin: 1vmax 0; */\n  border-bottom: 2px solid rgb(33, 38, 80);\n  /* margin-bottom: 1.5vmax; */\n  padding: 0.5vmax 5vmax;\n  color: rgb(7, 61, 128);\n}\n\n.asbuilt_div>:first-child>:first-child {\n  font-size: 2.5vmax;\n  letter-spacing: 0.2vmax;\n\n}\n\n.asbuilt_div>:first-child>:last-child {\n  font-size: 0.9vmax;\n  letter-spacing: 0.1vmax;\n}\n\n.asbuilt_div>:last-child {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 70vh;\n  padding: 0 2vmax;\n  display: flex;\n  justify-content: space-between;\n\n}\n\n\n.asbuilt_div>:last-child>:first-child {\n  border-right: 3px solid black;\n  width: fit-content;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n  flex-direction: column;\n  padding: 1vmax 0.5vmax 5vmax 1vmax;\n}\n\n.asbuilt_div>:last-child>:first-child>span {\n  letter-spacing: 0.1vmax;\n}\n\n.asbuilt_div>:last-child>:first-child>ul {\n  padding: 0.5vmax 0;\n  margin: 0;\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n  font-size: 1.3vmax;\n  text-align: end;\n\n}\n\n.asbuilt_div>:last-child>:first-child>ul>li {\n  list-style: none;\n  cursor: pointer;\n  color: black;\n  padding: 0.4vmax 0.8vmax;\n  position: relative;\n  letter-spacing: 0.050vmax;\n  font-weight: 500;\n  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;\n}\n\n/* ##### Code for Module and SLD container  */\n\n\n.module_div>li,\n.sld_div>li{\n  color: black;\n}\n.module_div,\n.sld_div {\n  white-space: nowrap;\n  overflow: hidden;\n  position: absolute;\n  z-index: 1;\n  height: auto;\n  left: 100%;\n  top: 15%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.3vmax;\n  border-radius: 4px;\n  /* box-shadow: rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset; */\n  /* box-shadow: 1px 1px 1px 2px black; */\n  /* background: linear-gradient(to right, #e8f8f4, #c6d5cf); */\n  /* border: 2px solid black; */\n  background: #fff;\n  background-color: #e8f8f4;\n  /* transition: width .5s ease-in-out; */\n  /* transition: .5s ease-in-out; */\n}\n.module_div li:hover,\n.sld_div li:hover{\n  transition: .2s ease-out;\n font-weight: 800;\n}\n.asbuilt_div>:last-child>:last-child {\n  box-sizing: border-box;\n  width: 80%;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 1vmax;\n  gap: 1.5vmax;\n\n\n\n}\n\n.asbuilt_div>:last-child>:last-child>div {\n  height: 18vmax;\n  width: 13vmax;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5vmax;\n\n\n}\n\n.asbuilt_div>:last-child>:last-child>div>div {\n  height: 100%;\n  width: 100%;\n  box-shadow: 2px 2px 4px black;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 8px;\n\n\n}\n\n.asbuilt_div>:last-child>:last-child>div>div>:first-child {\n  background: linear-gradient(to bottom, rgb(131, 131, 255), rgb(66, 227, 255));\n  background: linear-gradient(to right, #e8f8f4, #c6d5cf);\n  /* background: linear-gradient(to right, #bde3fd, #73c3fc); */\n  padding: 0.5vmax;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 0.5em;\n  font-size: 1.2vmax;\n  font-weight: 600;\n  opacity: 1.7;\n\n\n}\n\n.asbuilt_div>:last-child>:last-child>div>div>:last-child {\n  background-color: rgb(248, 95, 65);\n  cursor: pointer;\n  width: 100%;\n  padding: 0.5vmax 0;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5vmax;\n  font-weight: 700;\n  transition: .5s all;\n}\n\n.asbuilt_div>:last-child>:last-child>div>div>:last-child:hover {\n  background-color: rgb(255, 46, 4) !important;\n\n}\n.asbuilt_div>:last-child>:last-child>div>:last-child>link {\n  color: #05c059;\n}\n.categories {\n  font-size: 1.7vmax;\n  padding: 1vmax 0;\n  padding-right: 0.5vmax;\n  border-bottom: 3px solid black;\n  width: fit-content;\n  text-align: end;\n  font-weight: 600;\n}\n\n#excel_button,\n#pdf_button {\n  font-size: 1.2vmax;\n\n}\n\n#excel_button:hover {\n  background-color: #03db64 !important;\n}\n\n@media screen and (max-width:660px) {\n  .categories {\n    font-size: 1.4vmax;\n  }\n\n  .asbuilt_div>:last-child {\n    min-height: 45vh;\n  }\n\n  .asbuilt_div>:first-child>:first-child {\n    font-size: 3.5vmax;\n  }\n\n  .asbuilt_div>:first-child>:last-child {\n    font-size: 1.2vmax;\n  }\n}\n\n@media screen and (max-width:550px) {\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
